const ComparisonOperators = Object.freeze(['と等しい', 'と等しくない', '以上', '以下'])

export { ComparisonOperators }
